import TextField from '@mui/material/TextField';

const FromTextField =  ({
  label = "生産本部区分",
  helperText = "",
  onChange = (event: any) => { onChange(event); }
}) => (
  <TextField id="tfSeisanHonbuKbn"
    label={label}
    size="small"
    inputProps={{ maxLength: 6 }}
    onChange={(event: any) => { onChange(event); }}
    error={!!helperText}
    helperText={helperText}
  />
);

export default FromTextField;